import quickBIDesign from './_src/quickBIDesign.vue'
import ibItemDev from './_src/ibItemDev.vue'
quickBIDesign.install = function(Vue) {
  Vue.component(quickBIDesign.name, quickBIDesign)
  Vue.component(ibItemDev.name, ibItemDev)
}

export default quickBIDesign